import Instructions from './Instructions.component';

export default Instructions;



// WEBPACK FOOTER //
// ./src/ui/instructions/index.js